// extracted by mini-css-extract-plugin
export var author = "post-preview-module--author--62e79";
export var category = "post-preview-module--category--bc5f9";
export var excerpt = "post-preview-module--excerpt--50922";
export var headline = "post-preview-module--headline--b2a0d";
export var headlinePost = "post-preview-module--headline-post--3d62a";
export var hideImage = "post-preview-module--hide-image--8886d";
export var image = "post-preview-module--image--16ffc";
export var paragraph = "post-preview-module--paragraph--a7ef8";
export var post = "post-preview-module--post--e1026";
export var postWrapper = "post-preview-module--post-wrapper--cd8b0";